export const statusInfoMap = new Map([
  [
    0,
    {
      backgroundColor: 'rgba(0,195,88,0.08)',
      color: '#03BA78',
    },
  ],
  [
    10,
    {
      backgroundColor: 'rgba(0,195,88,0.08)',
      color: '#03BA78',
    },
  ],
  [
    20,
    {
      backgroundColor: 'rgba(0,195,88,0.08)',
      color: '#03BA78',
    },
  ],
  [
    30,
    {
      backgroundColor: 'rgba(0,195,88,0.08)',
      color: '#03BA78',
    },
  ],
  [
    40,
    {
      backgroundColor: 'rgba(0,195,88,0.08)',
      color: '#03BA78',
    },
  ],
  [
    50,
    {
      backgroundColor: 'rgba(0,0,0,0.04)',
      color: '#000000',
    },
  ],
  [
    60,
    {
      backgroundColor: 'rgba(0,0,0,0.04)',
      color: '#F7981C',
    },
  ],
  [
    70,
    {
      backgroundColor: 'rgba(0,0,0,0.04)',
      color: '#F7981C',
    },
  ],
])

// 1非常不满意，2不满意，3一般，4满意，5非常满意
export const starEvaluation = new Map([
  [1, '非常不满意'],
  [2, '不满意'],
  [3, '一般'],
  [4, '满意'],
  [5, '非常满意'],
])

// 0待派单，10待接单，20待交付，30待确定，40已完成，50已取消
export const detailStatusTextMap = new Map([
  [0, '待交付产品'],
  [10, '待交付产品'],
  [20, '待交付产品'],
  [30, '待确认交付'],
  [40, '已完成'],
  [50, '已取消'],
])
